import classNames from 'classnames'
import React from 'react'
import {Text, TYPOGRAPHY} from 'wix-ui-tpa/Text'
import {classes} from './no-events-text.st.css'

export const NoEventsText = props => (
  <Text
    typography={TYPOGRAPHY.smallTitle}
    {...props}
    className={classNames(classes.root, {[classes.mobile]: props.mobile})}
  />
)
